export class AssertionError extends Error {}

export function assert<TCondition>(condition: TCondition, msg: string): asserts condition {
  if (!condition) {
    throw new AssertionError(msg);
  }
}
